export const RADIO_INPUT_LAYOUT_ALIGNED = 'aligned';
export const RADIO_INPUT_LAYOUT_STACKED = 'stacked';
export const RADIO_INPUT_LAYOUT = {
	ALIGNED: RADIO_INPUT_LAYOUT_ALIGNED,
	STACKED: RADIO_INPUT_LAYOUT_STACKED
}
export const RADIO_INPUT_LAYOUTS = [RADIO_INPUT_LAYOUT_ALIGNED, RADIO_INPUT_LAYOUT_STACKED];